import React from 'react';
import styled from 'styled-components';
import Typography from '../../kingpin/atoms/Typography';
import Row from '../../components/Common/Row';
import Card from '../../kingpin/atoms/Card';
import OrderDetailsMap from '../../components/OrderDetailsMap';
import OrderDetailsProvider from '../../contextProviders/OrderDetailsProvider';

const ScreenDiv = styled.div`
  overflow-y: scroll;
  padding: 16px 24px;
`;

const LaneDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-border-primary);
  background-color: var(--color-bg-sunken);
  height: 40px;
  border-radius: 6px;
`;

const Heading = ({ children }: { children: string }) => {
  return (
    <div style={{ marginBottom: 24, marginTop: 16 }}>
      <Typography.Header type={'H3'}>{children}</Typography.Header>
    </div>
  );
};

const Content = ({ children }: { children: JSX.Element | JSX.Element[] }) => (
  <div style={{ marginBottom: 24 }}>{children}</div>
);

const DetailCard = ({ title, body }: { title: string; body: string }) => (
  <Card style={{ flex: 1 }}>
    <div>
      <div style={{ marginBottom: 4 }}>
        <Typography.Header type={'H4'} color="var(--color-text-secondary)">
          {title}
        </Typography.Header>
      </div>
      <Typography.Header type={'H1'}>{body}</Typography.Header>
    </div>
  </Card>
);

const OrderMap = () => {
  return (
    <Card>
      <div style={{ marginBottom: 8 }}>
        <OrderDetailsProvider orderNumber="3882712">
          <OrderDetailsMap height={238} />
        </OrderDetailsProvider>
      </div>
      <LaneDiv>
        <Typography.Header type={'H4'}>
          {'Raleigh,NC -> Lakewood,NJ'}
        </Typography.Header>
      </LaneDiv>
    </Card>
  );
};

const MetricCard = ({ title, value }: { title: string; value: string }) => (
  <Card>
    <Row spaceBetween centerAlign>
      <Typography.Header type={'H4'} color={'var(--color-info-v2)'}>
        {title}
      </Typography.Header>
      <Typography.Header type={'H2'}>{value}</Typography.Header>
    </Row>
  </Card>
);

const DetailRow = ({ title, value }: { title: string; value: string }) => (
  <Row centerAlign spaceBetween>
    <div>
      <Typography.Body type={'Body 13'} color={'var(--color-text-tertiary)'}>
        {title}
      </Typography.Body>
    </div>
    <div>
      <Typography.Body type={'Body 13 Bold'}>{value}</Typography.Body>
    </div>
  </Row>
);

const BasicDetails = () => (
  <Card>
    <div
      style={{
        borderBottom: '1px dashed var(--color-border-tertiary)',
        paddingBottom: 12,
        marginBottom: 12,
      }}
    >
      <Typography.Body type={'Body Bold'}>Basic Details</Typography.Body>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <DetailRow title={'Length Of Service'} value={'16M'} />
      <DetailRow title={'Team'} value={'False'} />
      <DetailRow title={'Type'} value={'Trainer'} />
      <DetailRow title={'Next planned home time'} value={'2/16'} />
    </div>
  </Card>
);

const Metrics = () => (
  <div>
    <div style={{ marginBottom: 16 }}>
      <MetricCard title={'Average Weekly Miles'} value={'2150'} />
    </div>
    <div style={{ marginBottom: 16 }}>
      <MetricCard title={'Average Weekly Pay'} value={'$1150'} />
    </div>
    <div style={{ marginBottom: 16 }}>
      <MetricCard title={'MPG'} value={'7.82'} />
    </div>
    <div style={{ marginBottom: 16 }}>
      <MetricCard title={'Violations'} value={'2'} />
    </div>
  </div>
);

const DriverDetailsTab = () => {
  return (
    <ScreenDiv>
      <Heading>Current Status</Heading>
      <Content>
        <Row spaceBetween style={{ gap: 24 }}>
          <DetailCard title={'Current Duty Status'} body={'Driving'} />
          <DetailCard title={'Drive Hours Remaining'} body={'4h 32m'} />
          <DetailCard title={'Cycle Remaining'} body={'56d 28h'} />
        </Row>
      </Content>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '24px',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
          }}
        >
          <Heading>Journey</Heading>
          <Content>
            <OrderMap />
          </Content>
        </div>
        <div style={{ flex: 1 }}>
          <Heading>Metrics</Heading>
          <Content>
            <Metrics />
          </Content>
        </div>
      </div>
      <div style={{ paddingBottom: 100 }}>
        <BasicDetails />
      </div>
    </ScreenDiv>
  );
};

export default DriverDetailsTab;
